/**
 * Membership module
 * Contains logic for membership/add view
 * @module
 */
import BEM from 'bem.js';
import moment from 'moment';
import { BLOCK_RADIO, MODIFIER_BUTTON } from '../../components/form';
import { MemberFactory, PriceConsumer } from '../../data/membership/price';


const BLOCK_OLD_MEMBER = 'old-member';
const BLOCK_FORM = 'form';
const BLOCK_DATEPICKER = 'datepicker';
const BLOCK_PRICES = 'prices';

const ELEMENT_MEMBER = 'member';
const ELEMENT_DISCOUNT = 'discount';
const ELEMENT_PRICE = 'price';
const ELEMENT_TOTAL = 'total';

const FORM = BEM.getBEMNode(BLOCK_FORM);
const OLD_MEMBER = BEM.getBEMNode(BLOCK_OLD_MEMBER);
const PRICES_MEMBER = BEM.getBEMNode(BLOCK_PRICES, ELEMENT_MEMBER);
const PRICE_MEMBER = (PRICES_MEMBER) ? BEM.getChildBEMNode(PRICES_MEMBER, BLOCK_PRICES, ELEMENT_PRICE) : null;
const PRICES_DISCOUNT= BEM.getBEMNode(BLOCK_PRICES, ELEMENT_DISCOUNT);
const PRICE_DISCOUNT = (PRICES_DISCOUNT) ? BEM.getChildBEMNode(PRICES_DISCOUNT, BLOCK_PRICES, ELEMENT_PRICE) : null;
const PRICES_TOTAL= BEM.getBEMNode(BLOCK_PRICES, ELEMENT_TOTAL);
const PRICE_TOTAL= (PRICES_TOTAL) ? BEM.getChildBEMNode(PRICES_TOTAL, BLOCK_PRICES, ELEMENT_PRICE) : null;


/**
 * Formset class
 * Contains logic for the add member form
 * @class
 */
class MemberCalculation {
    /**
     * Constructor method
     * Gets called when class get instantiated
     */
    constructor() {
        this.memberFactory = new MemberFactory();
        this.priceConsumer = new PriceConsumer();

        this.setUpUpdatePrice();
        setTimeout(this.updatePrice.bind(this), 0);
    }

    /**
     * Binds visit/datepicker change to this.updatePrice()
     */
    setUpUpdatePrice() {
        FORM.addEventListener('change', (e) => {
            let node = e.target;

            if (node.className.match(BEM.getBEMClassName(BLOCK_RADIO, false, MODIFIER_BUTTON)) ||
                node.className.match(BLOCK_DATEPICKER)) {
                this.updatePrice();
            }
        });
    }

    /**
     * Updates the price information by performing an API request
     * Creates an array of Member instances
     * Excludes member without birthdate
     * Calls API to get price for matching members
     */
    updatePrice() {
        let memberForm = FORM;
        let members = [];

        // Creates an array of Member instances
        let birthdate = BEM.getChildBEMNode(memberForm, BLOCK_DATEPICKER);
        let visit = memberForm.querySelector('input[type="radio"]:checked');

        if(moment(birthdate.value, 'YYYY-MM-DD', true).isValid()){
            if (birthdate && visit) {
                members.push(this.memberFactory.addMember({ birthdate: birthdate.value, visit: visit.value }));
            }
        }

        // Excludes member without birthdate
        members = members.filter((member) => member.birthdate && member.visit);

        // Calls API to get price for matching members
        if (members.length) {
            this.priceConsumer.getPriceForMembers(members)
                .then(this.renderPrice.bind(this))
                .catch(console.error);  // jshint ignore:line
        }
    }

    /**
     * Updates DOM with new pricing information
     * @param {Price} price
     */
    renderPrice(price) {
        PRICE_MEMBER.innerText = price.sub_total.replace('.', ',');
        PRICE_DISCOUNT.innerText = price.discount.replace('.', ',');
        PRICE_TOTAL.innerText = price.total.replace('.', ',');
    }
}

if (OLD_MEMBER) {
    new MemberCalculation();
}



// WEBPACK FOOTER //
// ./src/my_artis/js/views/membership/change.js